if (!customElements.get("popup-modal")) {
  customElements.define(
    "popup-modal",
    class PopupModal extends HTMLElement {
      constructor() {
        super();
        this.popupId = this.getAttribute("data-popup-id");
        this.popupEl = this.querySelector(".mm__popup");
        this.cookie = `${window.cookiePrefix}seen_${this.popupId}`;
        this.hasSeen = Cookies.get(this.cookie) === "true";
        this.delay = this.getAttribute("data-delay") ? parseInt(this.getAttribute("data-delay")) : 5000;
        this.expiration = this.getAttribute("data-expiration") ? parseInt(this.getAttribute("data-expiration")) : 7;
        if (!Shopify.designMode) {
          document.addEventListener("DOMContentLoaded", this.onContentLoaded.bind(this));
        } else {
          document.addEventListener("shopify:block:select", this.onBlockSelect.bind(this));
        }
      }

      onBlockSelect(event) {
        const targetId = `popup-${event.detail.blockId}`;
        if (targetId == this.popupId && !this.popupEl.classList.contains("is-open")) {
          this.showPopup();
          document.addEventListener("shopify:block:deselect", this.onBlockDeselect.bind(this), { once: true });
        }
      }

      onBlockDeselect(event) {
        const targetId = `popup-${event.detail.blockId}`;
        if (targetId == this.popupId && this.popupEl.classList.contains("is-open")) {
          this.hidePopup();
        }
      }

      onContentLoaded() {
        if (this.hasSeen) return;
        setTimeout(() => {
          this.showPopup();
        }, this.delay);
      }

      showPopup() {
        MicroModal.show(this.popupId, {
          onShow: (modal) => {
            document.body.classList.add("overflow-hidden");
            addScrollbarPadding();
          },
          onClose: (modal) => {
            document.body.classList.remove("overflow-hidden");
            removeScrollbarPadding();
          },
          disableFocus: true,
          awaitOpenAnimation: true,
        });

        Cookies.set(this.cookie, "true", { expires: this.expiration });
      }

      hidePopup() {
        MicroModal.close(this.popupId);
      }
    }
  );
}
